module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov4-f8e1500c04ca5a9d6e75414885cbcfd9.jpg";